var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPageBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 940,
    viewBox: "0 0 1440 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6832_4787)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6832_4787)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1119.63,
    transform: "translate(0 -179.37)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6832_4787)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1064.86,
    cy: 431.276,
    rx: 138.864,
    ry: 132.386,
    fill: "#67EAD0",
    fillOpacity: 0.28
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6832_4787)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1219.67,
    cy: -149.74,
    r: 548,
    fill: "url(#paint0_radial_6832_4787)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6832_4787)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1026.2,
    cy: 179.827,
    rx: 119.379,
    ry: 114.779,
    fill: "#67EAD0",
    fillOpacity: 0.28
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_6832_4787)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 928.763,
    cy: 157.259,
    rx: 39.0595,
    ry: 37.5544,
    fill: "#1079F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6832_4787)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.5,
    cy: 1052.75,
    rx: 279.5,
    ry: 266.462,
    fill: "#67EAD0",
    fillOpacity: 0.28
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter4_f_6832_4787)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 769.5,
    cy: 939.81,
    rx: 619.5,
    ry: 590.602,
    fill: "#CAE0FC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6832_4787",
    x: 666,
    y: 38.89,
    width: 797.729,
    height: 784.773,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    result: "effect1_foregroundBlur_6832_4787"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6832_4787",
    x: 671.737,
    y: -170.035,
    width: 708.924,
    height: 699.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 117.542,
    result: "effect1_foregroundBlur_6832_4787"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6832_4787",
    x: 705.253,
    y: -64.745,
    width: 447.019,
    height: 444.009,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.225,
    result: "effect1_foregroundBlur_6832_4787"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6832_4787",
    x: -140,
    y: 526.283,
    width: 1079,
    height: 1052.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    result: "effect1_foregroundBlur_6832_4787"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_6832_4787",
    x: -110,
    y: 89.2076,
    width: 1759,
    height: 1701.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    result: "effect1_foregroundBlur_6832_4787"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6832_4787",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1219.67 -149.74) rotate(90) scale(548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6832_4787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 940,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6832_4787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1119.63,
    fill: "white",
    transform: "translate(0 -179.37)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6832_4787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1096,
    height: 578,
    fill: "white",
    transform: "translate(671.668 -179.74)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPageBg);
export default __webpack_public_path__ + "static/media/video-page-bg.397eea0b0cba49a27e05851ea7771fde.svg";
export { ForwardRef as ReactComponent };